import React, { useRef, useContext, useMemo } from 'react'
import ReactDOM from 'react-dom'
import Loading from './Loading'
import Input from './Input'
import Confirmation from './Confirmation'
import ImageEdit from './ImageEdit'
import ImageUpload from './ImageUpload'
// import Image from './Image'
import Icon from './Icon'
// import AmazonSelector from './AmazonSelector'
// import ArticleHighlighter from './ArticleHighlighter'
import { withRouter } from 'react-router'
import { debounce } from '../modules/helpers'
import { INPUT_DEBOUNCE_TIME, FRONT_STORE_ARRAY } from '../constants/'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { post } from '../modules/fetch'
import { differenceInSeconds } from 'date-fns'
import Button from './Button'
import { If } from '../modules/helpers'
import { ArticleEditContext } from './ArticleEdit'
import Switch from './Switch'
import Clipboard from 'react-clipboard.js'
import { useWhyDidYouUpdate } from 'use-why-did-you-update'
const uuidv4 = require('uuid/v4')

const beginsWithSlash = (url) => url.substring(0, 1) === '/'
export const isLinkLegit = (site) => (url) => {
    // either contains site url, or begins with a slash
    // return url.includes(site.url) || beginsWithSlash(url)
    const store_url = FRONT_STORE_ARRAY.find((fs) => fs.locale === site.locale)?.url
    const isLinkLegit = site.permalink_array?.some((a) => 'https://' + site.url + '/' + a.permalink === url) || url.includes(store_url) || beginsWithSlash(url)
    // !isLinkLegit && console.error('Invalid link found', url)
    return isLinkLegit
    // site.permalink_array?.some(a => 'https://'+site.url+'/'a.permalink===url)
}

export const getFlatBlockArray =
    (block_id_array) =>
    (b, acc = []) => {
        if (b.block_id_array) {
            acc = [
                ...acc,
                ...b.block_id_array.reduce((_acc, _bid) => {
                    return [..._acc, ...getFlatBlockArray(block_id_array)(block_id_array.find((__b) => __b.id === _bid))]
                }, []),
            ]
        } else {
            acc.push(b)
        }
        return acc
    }

// const affiliate_type_array = ['amazon', 'text-link']
const amazon_default_content = '[amazon]'

window.drag_target_id = null
window.drag_target = null
window.drag_text = null

let body_sync = {}
const generateBlockIndex = () => uuidv4()
const new_block_array = [
    {
        display: true,
        type: 'text',
        id: 'text',
        label: 'Text',
        icon: <i className="fa fa-font" />,
    },
    {
        display: true,
        type: 'title',
        id: 'title',
        label: 'Title',
        icon: <i className="fa fa-h2" />,
    },
    {
        display: true,
        type: 'subtitle',
        id: 'subtitle',
        label: 'Subtitle',
        icon: <i className="fa fa-h3" />,
    },
    {
        display: true,
        type: 'insert',
        id: 'insert',
        label: 'Insert',
        icon: <i className="fas fa-comment-alt" />,
    },
    {
        display: true,
        type: 'article',
        id: 'article',
        label: 'Article',
        icon: <i className="fas fa-newspaper" />,
    },
    {
        display: true,
        type: 'blockquote',
        id: 'blockquote',
        label: 'BlockQuote',
        icon: <i className="fas fa-quote-left" />,
    },
    {
        display: true,
        type: 'lead',
        id: 'lead',
        label: 'Lead',
        icon: <i className="fa fa-hat-cowboy-side" />,
    },
    {
        display: true,
        type: 'toc',
        id: 'toc',
        label: 'Table of contents',
        icon: <i className="fa fa-list" />,
    },
    {
        display: true,
        type: 'image',
        id: 'image',
        label: 'Image',
        icon: <i className="fa fa-image" />,
    },
    {
        display: false,
        type: 'amazon',
        id: 'amazon',
        label: 'Amazon',
        icon: <i className="fab fa-amazon" />,
    },
    {
        display: false,
        type: '1col',
        id: '1col',
        label: '1 col',
        icon: <i className="fa fa-square" />,
    },
    {
        display: true,
        type: '2cols',
        id: '2cols',
        label: '2 cols',
        icon: <i className="fa fa-equals fa-rotate-90" />,
    },
    {
        display: true,
        type: '3cols',
        id: '3cols',
        label: '3 cols',
        icon: <i className="fa fa-bars fa-rotate-90" />,
    },
]

let time = {}
let time_fn_holer = {}
let timeout = {}
const time_limit = 60000 // in ms
const logTime = (article_id, immediate = false) => {
    // console.log('hello!', article_id, '---', time[article_id], timeout)
    const end = new Date()
    const deduce = (!immediate && time_limit / 1000) || 0
    const time_logged = differenceInSeconds(end, time[article_id]) - deduce
    // console.log(time_logged)
    article_id && time_logged && post('activity_log', { article_id, time: time_logged })
}
const debouncedLogTime = (article_id) => {
    clearTimeout(timeout[article_id])
    timeout[article_id] = setTimeout(() => {
        logTime(article_id)
        startChrono(article_id)
    }, time_limit)
}
// const logTime = () => { console.log('hello!') }
const startChrono = (article_id) => {
    time[article_id] = new Date()
}
const monitorEditingTime = (article_id) => {
    startChrono(article_id)
    time_fn_holer[article_id] = () => debouncedLogTime(article_id)
    document.addEventListener('keydown', time_fn_holer[article_id])
    document.addEventListener('mousemove', time_fn_holer[article_id])
    window.addEventListener('scroll', time_fn_holer[article_id])
}
const unmonitorEditingTime = (article_id) => {
    clearTimeout(timeout[article_id])
    document.removeEventListener('keydown', time_fn_holer[article_id])
    document.removeEventListener('mousemove', time_fn_holer[article_id])
    window.removeEventListener('scroll', time_fn_holer[article_id])
    logTime(article_id, true)
}

class PageEditor extends React.PureComponent {
    updateAmazon

    constructor(props) {
        super(props)
        // let body = this.props.content||[{ type: 'root', id: 'root', block_id_array: [] }]
        let body =
            (typeof this.props.value === 'string' && this.props.value.substring(0, 1) === '[' && JSON.parse(this.props.value)) ||
            (this.props.value && typeof this.props.value === 'object' ? this.props.value : [{ type: 'root', id: 'root', block_id_array: [] }])
        if (Array.isArray(body) && body.length === 0) {
            body = [{ type: 'root', id: 'root', block_id_array: [] }]
        }

        if (!body.find((block) => block.type === 'placeholder')) {
            body.push({ type: 'placeholder', id: 'placeholder', content: '' })
        }
        // console.log('HERE', { body }, this.props.value)
        this.state = {
            body,
            display_delete_modal: false,
            display_amazon_selector: false,
        }
        body_sync[this.props.id] = body
        // console.log(this.state.body, this.state.body.length, this.props.value)
    }

    componentDidMount() {
        monitorEditingTime(this.props.article.id)
    }
    componentWillUnmount() {
        unmonitorEditingTime(this.props.article.id)
    }

    setAmazonBlockContent = (param) => {
        this.updateAmazon(param)
    }

    getRootBlock = () => this.state.body.find((block) => block.id === 'root')

    getRootBlocks = () =>
        this.state.body.reduce((acc, block) => {
            if (~this.getRootBlock().block_id_array.indexOf(block.id)) {
                acc.push(block)
            }
            return acc
        }, [])

    onDragStartNewBlock = (e, param) => {
        e.dataTransfer.setData('text/plain', '')
        window.drag_target = null
        window.drag_target_id = param
        window.drag_text = 'Lorem ipsum dolor sit amet'
    }

    updateBody = (body) => {
        // console.log('updating body', body)
        const target_text_link_array = body
            .filter((item) => item.type === 'text')
            .reduce((acc, block) => {
                block.content &&
                    block.content.source &&
                    block.content.source.entityMap &&
                    Object.values(block.content.source.entityMap)
                        .filter((entity) => entity.type === 'LINK')
                        .map((entity) => {
                            // console.log('checking', entity)
                            !entity.data.id && (entity.data.id = generateBlockIndex())
                            return acc.push({
                                type: 'text-link',
                                id: entity.data.id,
                                content: { url: entity.data.url },
                            })
                        })
                return acc
            }, [])
        // add new blocks if needed
        let new_blocks = target_text_link_array.map((new_block) => !body.find((block) => block.id === new_block.id) && new_block).filter(Boolean)
        new_blocks = new_blocks.map((new_block) => {
            const candidate = this.props.product_bucket_array.find((prod) => prod.href === new_block.content.url)
            if (candidate) {
                new_block = {
                    ...new_block,
                    content: { ...new_block.content, ...candidate },
                    text: 1,
                }
            }
            return new_block
        })
        // remove text-link blocks after a text has been deleted
        const filtered_text_link_array = body
            .filter((block) => block.type === 'text-link')
            .filter((block) =>
                body.find(
                    (text_block) =>
                        text_block.type === 'text' &&
                        ((text_block.content && text_block.content.source && Object.values(text_block.content.source.entityMap)) || [])
                            .filter((entity) => entity.type === 'LINK')
                            .find((entity) => entity.data.id === block.id)
                )
            )
        body = [...body.filter((block) => block.type !== 'text-link'), ...filtered_text_link_array, ...new_blocks]
        body_sync[this.props.id] = body
        body = body.filter((block) => !!block.type)

        // remove orphans:
        body = body.filter((b) => b.type === 'root' || b.type === 'placeholder' || body.find((sb) => sb.block_id_array && !!~sb.block_id_array.indexOf(b.id)))
        // remove additional_blocks
        body = body.map((b) => {
            const { additional_blocks, ...temp } = b
            return temp
        })

        this.setState({ body })
        this.props.onChange && this.props.onChange({ target: { name: this.props.name, value: body } })
    }

    toggleDeleteModalState = () => this.setState({ display_delete_modal: !this.state.display_delete_modal })

    askToDeleteBlock = (block_id) => {
        this.toggleDeleteModalState()
        this.setState({ delete_target_id: block_id })
    }

    deleteBlock = (block_id) => {
        // console.log('deleting', block_id)
        const body = this.state.body.reduce((acc, block) => {
            if (block.block_id_array && ~block.block_id_array.indexOf(block_id)) {
                acc.push({
                    ...block,
                    block_id_array: block.block_id_array.filter((id) => id !== block_id),
                })
            } else if (block.id !== block_id) {
                acc.push(block)
            }
            return acc
        }, [])
        this.updateBody(body)
    }

    setAmazonSelectorVisible = (display_amazon_selector, update) => {
        this.updateAmazon = update
        // this.setState({ display_amazon_selector })
        this.props.setAmazonSelectorVisible(display_amazon_selector, update)
    }

    render() {
        const entityRanges = this.state.body
            .filter((item) => item.type === 'text')
            .reduce((acc, block) => {
                block.content &&
                    block.content.source &&
                    block.content.source.blocks &&
                    block.content.source.blocks.map((draftblock) => {
                        acc = [
                            ...acc,
                            ...draftblock.entityRanges.map((e, index) => ({
                                ...e,
                                index,
                                entityKey: draftblock.key,
                                depth: draftblock.depth,
                            })),
                        ]
                    })
                return acc
            }, [])
        const entityMapItems = this.state.body
            .filter((item) => item.type === 'text')
            .reduce((acc, block) => {
                block.content &&
                    block.content.source &&
                    block.content.source.entityMap &&
                    Object.values(block.content.source.entityMap).map((entityMapItem) => {
                        acc.push(entityMapItem)
                    })
                return acc
            }, [])

        const link_entity_array = entityRanges
            .map((entity, index) => ({
                key: entity.entityKey,
                index: entity.index,
                type: entityMapItems[entity.key].type,
                id: entityMapItems[entity.key].data.id,
            }))
            .filter((item) => item.type === 'LINK')
        // console.log({entityMapItems})
        // console.log({link_entity_array})

        // console.log(this.getRootBlocks())
        const drag_drop_props = (type) => ({
            draggable: true,
            onDragStart: (e) => this.onDragStartNewBlock(e, type),
            onDrop: () => {
                console.log('element dropped')
            },
            onDragOver: (event) => event.preventDefault(),
            onDragEnd: () => {
                console.log('onDragEnd')
            },
        })
        return (
            <React.Fragment>
                <div id="block-toolbar-container" />
                <BlockToolbar
                    drag_drop_props={drag_drop_props}
                    status={this.props.status}
                    needs_to_be_saved={this.props.needs_to_be_saved}
                    setDisplayTranslationUI={this.props.setDisplayTranslationUI}
                    displayTranslationUI={this.props.displayTranslationUI}
                />
                <div className="row">
                    <div className="col-12">
                        <Block
                            {...this.getRootBlock()}
                            body={this.state.body}
                            editor={true}
                            updateBody={this.updateBody}
                            object_id={this.props.id}
                            askToDeleteBlock={this.askToDeleteBlock}
                            article_id={this.props.match.params.id}
                            article={this.props.article}
                            site_id={this.props.site_id}
                            site={this.props.site}
                        />
                        {/* {this.state.body.filter(block => block.type==='text-link').map((block, index) => <div key={index} id={`block-${block.id}`}>{block.content.url}</div>)} */}
                    </div>
                </div>
                <Confirmation
                    isOpen={this.state.display_delete_modal}
                    toggle={this.toggleDeleteModalState}
                    confirm={() => this.deleteBlock(this.state.delete_target_id)}
                    title={'Delete'}
                    text={'Are you sure you want to delete this block'}
                />
                {/* <ArticleHighlighter affiliate_block_array={this.state.body.filter(block => ~affiliate_type_array.indexOf(block.type))} link_entity_array={link_entity_array} setAmazonSelectorVisible={this.setAmazonSelectorVisible} unavailable_link_array={this.props.unavailable_link_array} /> */}
            </React.Fragment>
        )
    }
}

const BlockToolbar = function BlockToolbar(props) {
    const target = useRef(null)
    !target.current && (target.current = document.querySelector('#block-toolbar-container'))
    const status = props.status
    const needs_to_be_saved = props.needs_to_be_saved
    const { article, displayTranslationUI, setDisplayTranslationUI } = useContext(ArticleEditContext)

    return (
        (target.current &&
            ReactDOM.createPortal(
                <div id="block-toolbar">
                    <div className="row">
                        <div className="col-12">
                            <ul className="list-unstyled mb-0 text-center d-flex align-items-center justify-content-center">
                                {(article.translated_from__article_id && (
                                    <li className="d-inline-block pt-1">
                                        <Switch
                                            id="translation-switch"
                                            checked={displayTranslationUI}
                                            onChange={() => setDisplayTranslationUI(!displayTranslationUI)}
                                        />
                                        {/* <label htmlFor="translation-switch">Translations</label> */}
                                    </li>
                                )) ||
                                    null}
                                {new_block_array.map(
                                    (new_block) =>
                                        (new_block.display && (
                                            <li
                                                key={`new-block-${new_block.type}`}
                                                className={'btn btn-dark btn-sm page-editor-block-icon'}
                                                {...props.drag_drop_props(new_block.type)}
                                            >
                                                {new_block.icon}
                                            </li>
                                        )) ||
                                        null
                                )}
                                <li className="d-inline-block ml-3">
                                    <Button className={((needs_to_be_saved && 'btn-success') || 'btn-primary') + ' btn btn-sm page-editor-block-icon'}>
                                        <If true={status === 'ready'}>
                                            <span>
                                                <i className="fa fa-save" />
                                            </span>
                                        </If>
                                        <If true={status === 'loading'}>
                                            <span>
                                                <i className="fal fa-circle-notch fa-spin" />
                                            </span>
                                        </If>
                                        <If true={status === 'saved'}>
                                            <span>
                                                <i className="fa fa-save" />
                                            </span>
                                        </If>
                                    </Button>
                                </li>
                                <li>
                                    <UncontrolledDropdown>
                                        <DropdownToggle caret color="secondary" className="btn-sm ml-3 page-editor-block-icon">
                                            <i className="fal fa-sitemap" />
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            {(article.site?.permalink_array || []).map((p, index) => (
                                                <Clipboard
                                                    key={index}
                                                    component="div"
                                                    data-clipboard-text={`https://${article.site?.url}/${p.permalink === 'homepage' ? '' : p.permalink}`}
                                                >
                                                    <DropdownItem>
                                                        <i className="fal fa-copy mr-2" />
                                                        <strong>{p.title}</strong>
                                                        {/* <br />/{p.permalink === 'homepage' ? '' : p.permalink} */}
                                                    </DropdownItem>
                                                </Clipboard>
                                            ))}
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>,
                target.current
            )) ||
        null
    )
}

const Block = (props) => {
    // const block_definition = props.body?.find((b) => b.id === props.id)
    // console.log({ props }, [
    //     ...Object.keys(props)
    //         .filter((k) => k !== 'body')
    //         .map((k) => (typeof props[k] !== 'function' ? props[k] : undefined))
    //         .filter(Boolean),
    //     block_definition,
    // ])
    // useWhyDidYouUpdate('Block', props)
    // return useMemo(() => <BlockMiddleware {...props} />, [
    //     JSON.stringify(
    //         Object.keys(props)
    //             .filter((k) => k !== 'body')
    //             .map((k) => (typeof props[k] !== 'function' ? props[k] : undefined))
    //             .filter(Boolean)
    //     ),
    // ])
    return <BlockContained {...props} />
}

const BlockMiddleware = (props) => {
    useWhyDidYouUpdate('BlockMiddleware', props)
    return <BlockContained {...props} />
}

class BlockContained extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            cleanUp: 0, // used to force children to update - usually they update themsevles and tell this component about the change
            convertLinks: 0,
        }
    }

    onDragStart = (e, param) => {
        e.dataTransfer.setData('text/plain', '')
        window.drag_target = {
            ...body_sync[this.props.object_id].find((block) => block.id === param),
        }
        window.drag_target_id = window.drag_target.id
        console.log(param, { drag_target_id: window.drag_target_id })
    }
    onDragOver = (e) => {
        e && e.preventDefault()
        e && e.stopPropagation()
        const mouse_y = e.pageY
        const target_pointer = document.querySelector(`#block-${window.drag_target_id}`)

        if (target_pointer) {
            const placeholder_coords = target_pointer.getBoundingClientRect()
            const placeholder_coords_top = placeholder_coords.top + window.scrollY
            if (mouse_y > placeholder_coords_top && mouse_y < placeholder_coords_top + placeholder_coords.height) {
                return
            }
        }
        const content = this.props.block_id_array
            .filter((block_id) => body_sync[this.props.object_id].find((block) => block.id === block_id).type !== 'placeholder')
            .reduce(
                (acc, block_id) => {
                    const block_candidate = document.querySelector(`#block-${block_id}`)
                    if (block_candidate) {
                        const block_y = block_candidate.getBoundingClientRect().top + window.scrollY
                        if (acc.y < mouse_y && mouse_y < block_y) {
                            acc.block_id_array.push('placeholder')
                            acc.y = block_y
                        }
                    }
                    acc.block_id_array.push(block_id)
                    return acc
                },
                { y: 0, block_id_array: [] }
            )
        if (content.y === 0) {
            content.block_id_array.push('placeholder')
        }

        const block_id_array = (content.block_id_array.length && content.block_id_array) || ['placeholder']
        let diff = false
        if (block_id_array.length !== this.props.block_id_array.length) {
            diff = true
        } else {
            diff = block_id_array.reduce((acc, block_id, index) => {
                if (block_id !== this.props.block_id_array[index]) {
                    acc = true /*console.log(block_id, this.props.block_id_array[index])*/
                }
                return acc
            }, diff)
        }
        if (diff) {
            // console.log(diff)
            const duplicate = {
                ...body_sync[this.props.object_id].find((block) => block.id === this.props.id),
                block_id_array,
            }
            const body = body_sync[this.props.object_id].reduce((acc, block) => {
                if (block.id !== this.props.id) {
                    acc.push(block)
                } else {
                    acc.push(duplicate)
                }
                return acc
            }, [])
            this.props.updateBody(body)
        }
    }
    onDrop = (e) => {
        e && e.preventDefault()
        e && e.stopPropagation()
        // console.log('onDrop')
        // TODO: check if placeholder is in one of the block_id_array, of not, return
        if (!body_sync[this.props.object_id].find((block) => block.block_id_array && ~block.block_id_array.indexOf('placeholder'))) {
            return
        }

        const new_block_candidate = new_block_array.find((new_block) => new_block.id === window.drag_target_id)
        console.log(window.drag_target_id)
        let new_block = false
        if (new_block_candidate) {
            // console.log('dropped', new_block_array.find(new_block => new_block.id===window.drag_target_id))
            new_block = this.createNewBlock(window.drag_target_id)
            window.drag_target_id = new_block.id
            // console.log('new block:', new_block)
        }

        let body = body_sync[this.props.object_id]
        body = body.map((block) => {
            if (block.block_id_array && ~block.block_id_array.indexOf(window.drag_target_id)) {
                block = {
                    ...block,
                    block_id_array: block.block_id_array.filter((block_id) => block_id !== window.drag_target_id),
                }
                // console.log('REMOVED', window.drag_target_id, 'from', block.block_id_array)
            }
            return block
        })
        body = body.reduce((acc, block) => {
            if (block.block_id_array && ~block.block_id_array.indexOf('placeholder')) {
                block.block_id_array = block.block_id_array.reduce((acc, block_id) => {
                    if (block_id === 'placeholder') {
                        // console.log('pushing', window.drag_target_id)
                        acc.push(window.drag_target_id)
                    } else {
                        acc.push(block_id)
                    }
                    return acc
                }, [])
            }
            acc.push(block)
            return acc
        }, [])
        body.push({ ...new_block, additional_blocks: undefined })
        if (new_block.additional_blocks) {
            body = [...body, ...new_block.additional_blocks]
        }
        window.drag_target_id = null
        window.drag_target = null
        window.drag_target_payload = null
        // console.log({body})
        this.props.updateBody(body)
    }
    onDragLeave = (e) => {
        // console.log('onDragLeave', this.props.id)
        const body = body_sync[this.props.object_id].map((block) => {
            if (block.block_id_array && ~block.block_id_array.indexOf('placeholder')) {
                block = {
                    ...block,
                    block_id_array: block.block_id_array.filter((block_id) => block_id !== 'placeholder'),
                }
            }
            return block
        })
        // TODO: check if it has changed before actually updateBody
        this.props.updateBody(body)
    }

    createNewBlock = (type) => {
        const id = generateBlockIndex()
        let block = { id, type }
        let additional_blocks = null
        switch (type) {
            case 'text':
            case 'lead':
            case 'title':
            case 'subtitle':
            case 'blockquote':
            case 'insert':
                block.content = window.drag_text
                break
            case 'article':
            case 'toc':
                block.content = ''
                break
            case 'image':
                block.content = {}
                break
            case 'amazon':
                if (window.drag_target_payload) {
                    console.log(window.drag_target_payload)
                    block.payload = window.drag_target_payload
                    // {
                    //     "image_url": "https://images-eu.ssl-images-amazon.com/images/I/510zzJEGkwL.jpg",
                    //     "href": "https://www.amazon.fr/VBIGER-Unisexe-Gants-Hiver-Tactile/dp/B07FY9VXJW?psc=1&SubscriptionId=AKIAJW3YXEWYIPJWNEYA&tag=sac-de-metier-21&linkCode=xm2&camp=2025&creative=165953&creativeASIN=B07FY9VXJW",
                    //     "external_id": "B07FY9VXJW",
                    //     "provider": "amazon",
                    //     "query": "gants"
                    // }
                }
                block.content = amazon_default_content
                break
            case '1col':
                {
                    const text1 = this.createNewBlock('text')
                    additional_blocks = [text1]
                    block.block_id_array = [text1.id]
                }
                break
            case '2cols':
                {
                    const obj1 = this.createNewBlock('1col')
                    const obj2 = this.createNewBlock('1col')
                    additional_blocks = [obj1, obj2, ...obj1.additional_blocks, ...obj2.additional_blocks]
                    block.block_id_array = [obj1.id, obj2.id]
                }
                break
            case '3cols':
                {
                    const obj1 = this.createNewBlock('1col')
                    const obj2 = this.createNewBlock('1col')
                    const obj3 = this.createNewBlock('1col')
                    additional_blocks = [obj1, obj2, obj3, ...obj1.additional_blocks, ...obj2.additional_blocks, ...obj3.additional_blocks]
                    block.block_id_array = [obj1.id, obj2.id, obj3.id]
                }
                break
            default:
                block.content = window.drag_text
                break
        }

        return { ...block, additional_blocks }
    }

    renderContent = (content) => {
        let addon = null
        if (
            this.props.type === 'text' ||
            this.props.type === 'i18n-text' ||
            this.props.type === 'title' ||
            this.props.type === 'subtitle' ||
            this.props.type === 'lead' ||
            this.props.type === 'blockquote' ||
            this.props.type === 'insert'
        ) {
            addon = !this.validityFn(this.props.content?.source) ? (
                <>
                    <div
                        className="page-editor-icon-btn icon-warning-hover"
                        onClick={() => {
                            this.setState((s) => ({ ...s, cleanUp: this.state.cleanUp + 1 }))
                        }}
                    >
                        <i className="fal fa-unlink" />
                    </div>
                    <div
                        className="page-editor-icon-btn icon-warning-hover"
                        onClick={() => {
                            this.setState((s) => ({
                                ...s,
                                convertLinks: this.state.convertLinks + 1,
                            }))
                        }}
                    >
                        <i className="fal fa-link" />
                    </div>
                </>
            ) : (
                addon
            )
        }
        const visible = typeof this.props.visible !== 'undefined' ? this.props.visible : true
        return (
            (this.props.editor && (
                <div id={`block-${this.props.id}`} className={'page-editor-block' + (visible ? ' block-visible' : ' block-not-visible')}>
                    <BlockIcons
                        id={this.props.id}
                        onDragStart={this.onDragStart}
                        askToDeleteBlock={this.props.askToDeleteBlock}
                        type={this.props.type}
                        addon={addon}
                        visible={typeof this.props.visible === 'undefined' ? true : this.props.visible}
                        setVisible={this.setVisible}
                    />
                    <div className="page-editor-block-content">{content}</div>
                </div>
            )) ||
            content
        )
    }
    renderDroppable = (content) => {
        return (
            (this.props.editor && (
                <div
                    id={`droppable-${this.props.id}`}
                    className="page-editor-block page-editor-droppable py-3"
                    onDragOver={this.onDragOver}
                    onDragEnter={this.onDragEnter}
                    onDragLeave={this.onDragLeave}
                    onDrop={this.onDrop}
                >
                    {content}
                </div>
            )) ||
            content
        )
    }

    setVisible = (visible) => {
        console.log('calling setVisible', visible)
        const body = body_sync[this.props.object_id].reduce((acc, block) => {
            if (block.id === this.props.id) {
                acc.push({ ...block, visible })
            } else {
                acc.push(block)
            }
            return acc
        }, [])
        this.props.updateBody(body)
    }

    updateContent = (e, sticky) => {
        const body = body_sync[this.props.object_id].reduce((acc, block) => {
            if (block.id === this.props.id) {
                const payload = void 0 === e.target ? e : e.target.value
                acc.push({
                    ...block,
                    content: sticky
                        ? {
                              ...block.content,
                              original: payload.original || block.content.original || block.content.source,
                              ...payload,
                          }
                        : payload,
                })
            } else {
                acc.push(block)
            }
            return acc
        }, [])
        // console.log('updating', e.target.value)
        // console.log('updating', this.props.id, e.target.value, body)
        // if (this.props.type === 'text') {
        // console.log(e.target.value.source.entityMap && Object.values(e.target.value.source.entityMap).filter(item => item.type==='LINK'))
        // }
        this.props.updateBody(body)
    }

    updateMeta = (e, sticky) => {
        const body = body_sync[this.props.object_id].reduce((acc, block) => {
            if (block.id === this.props.id) {
                const payload = void 0 === e.target ? e : e.target.value
                acc.push({
                    ...block,
                    meta: sticky ? { ...block.meta, ...payload } : payload,
                })
            } else {
                acc.push(block)
            }
            return acc
        }, [])
        this.props.updateBody(body)
    }

    validityFn = (value) => {
        if (
            this.props.type === 'text' ||
            this.props.type === 'i18n-text' ||
            this.props.type === 'title' ||
            this.props.type === 'subtitle' ||
            this.props.type === 'lead' ||
            this.props.type === 'blockquote' ||
            this.props.type === 'insert'
        ) {
            // console.log('validity', value, Object.keys(value?.entityMap ?? []))
            const blockIsValid = Object.keys(value?.entityMap || {})
                .map((key) => value.entityMap[key])
                .filter((e) => e.type === 'LINK')
                .every((e) => isLinkLegit(this.props.article?.site)(e.data?.url))
            // !blockIsValid && console.error('INVALID BLOCK DETECTED', value)
            return blockIsValid
        }
        return true
    }

    render() {
        // console.log('Block rendered')
        if (this.props.type === 'placeholder') {
            return <div className="page-editor-placeholder" />
        } else if (this.props.type === 'toc') {
            const root = this.props.body.find((b) => b.type === 'root')
            const flat_block_array = getFlatBlockArray(this.props.body)(root)

            // console.log(
            //     this.props,
            //     { flat_block_array },
            //     flat_block_array.filter((b) => b.type === 'title')
            // )
            const renderTitleBlock = (b) => {
                let html = b?.content?.html
                // console.log(b?.content?.html?.substring(0, 3), b?.content?.html?.substring(b?.content?.html?.length - 4))
                if (b?.content?.html?.substring(0, 3) === '<p>' && b?.content?.html?.substring(b?.content?.html?.length - 4) === '</p>') {
                    html = b?.content?.html?.substring(3, b?.content?.html?.length - 4)
                }
                return html
            }
            const renderTitleBlockLi = (b) => (
                <li key={'title-' + b.id}>
                    {renderTitleBlock(b)}
                    {(b.subtitle_array.length && (
                        <ol className="subtitle">
                            {b.subtitle_array.map((sb) => {
                                return <li key={sb.id}>{renderTitleBlock(sb)}</li>
                            })}
                        </ol>
                    )) ||
                        null}
                </li>
            )
            return this.renderContent(
                <div className="toc-container">
                    <ol>
                        {flat_block_array
                            .filter((b) => b.type === 'title' || b.type === 'subtitle')
                            .reduce((acc, b) => {
                                if (b.type === 'title') {
                                    acc.push({ ...b, subtitle_array: [] })
                                } else if (b.type === 'subtitle') {
                                    acc[acc.length - 1].subtitle_array.push(b)
                                }
                                return acc
                            }, [])
                            .map(renderTitleBlockLi)}
                    </ol>
                </div>
            )
        } else if (this.props.type === 'amazon') {
            return this.renderContent(
                <AmazonBlock
                    setAmazonSelectorVisible={this.props.setAmazonSelectorVisible}
                    article_id={this.props.article_id}
                    article={this.props.article}
                    block_id={this.props.id}
                    content={this.props.content}
                    payload={this.props.payload || undefined}
                    onChange={this.updateContent}
                    unavailable_link_array={this.props.unavailable_link_array}
                />
            )
        } else if (this.props.type === 'text-link') {
            return this.renderContent(<div>text-link</div>)
        } else if (this.props.type === 'image') {
            return this.renderContent(
                <ImageEdit
                    article_id={this.props.article_id}
                    article={this.props.article}
                    site_id={this.props.site_id}
                    content={this.props.content}
                    image={this.props.content}
                    onChange={this.updateContent}
                />
            )
        } else if (this.props.type === 'title') {
            return this.renderContent(
                <h2>
                    <Input
                        type={this.props.article.translated_from__article_id ? 'i18n-advanced-textarea' : 'advanced-textarea'}
                        value={
                            void 0 !== this.props.content.original || !this.props.article.translated_from__article_id
                                ? this.props.content
                                : {
                                      ...this.props.content,
                                      original: this.props.content.source,
                                      source: undefined,
                                  }
                        }
                        onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                        validityFn={this.validityFn}
                        cleanUp={this.state.cleanUp}
                        convertLinks={this.state.convertLinks}
                    />
                </h2>
            )
            // return this.renderContent('blah')
        } else if (this.props.type === 'subtitle') {
            return this.renderContent(
                <h3>
                    <Input
                        type={this.props.article.translated_from__article_id ? 'i18n-advanced-textarea' : 'advanced-textarea'}
                        value={
                            void 0 !== this.props.content.original || !this.props.article.translated_from__article_id
                                ? this.props.content
                                : {
                                      ...this.props.content,
                                      original: this.props.content.source,
                                      source: undefined,
                                  }
                        }
                        onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                        validityFn={this.validityFn}
                        cleanUp={this.state.cleanUp}
                        convertLinks={this.state.convertLinks}
                    />
                </h3>
            )
            // return this.renderContent('blah')
        } else if (this.props.type === 'lead') {
            return this.renderContent(
                <div className="lead">
                    <Input
                        type={this.props.article.translated_from__article_id ? 'i18n-advanced-textarea' : 'advanced-textarea'}
                        value={
                            void 0 !== this.props.content.original || !this.props.article.translated_from__article_id
                                ? this.props.content
                                : {
                                      ...this.props.content,
                                      original: this.props.content.source,
                                      source: undefined,
                                  }
                        }
                        onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                        validityFn={this.validityFn}
                        cleanUp={this.state.cleanUp}
                        convertLinks={this.state.convertLinks}
                    />
                </div>
            )
            // return this.renderContent('blah')
        } else if (this.props.type === 'blockquote') {
            const { content, meta = {} } = this.props
            return this.renderContent(
                <div className="blockquote">
                    <div className="textarea">
                        <Input
                            type={this.props.article.translated_from__article_id ? 'i18n-advanced-textarea' : 'advanced-textarea'}
                            value={
                                void 0 !== this.props.content.original || !this.props.article.translated_from__article_id
                                    ? this.props.content
                                    : {
                                          ...this.props.content,
                                          original: this.props.content.source,
                                          source: undefined,
                                      }
                            }
                            onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                            validityFn={this.validityFn}
                            cleanUp={this.state.cleanUp}
                            convertLinks={this.state.convertLinks}
                        />
                    </div>
                    <div className="mt-2">
                        Author: <Input type="text" value={meta.author} onChange={(e) => this.updateMeta({ ...meta, author: e.target.value })} />
                    </div>
                </div>
            )
            // return this.renderContent('blah')
        } else if (this.props.type === 'insert') {
            return this.renderContent(
                <div className="insert">
                    <div className="textarea">
                        <Input
                            type={this.props.article.translated_from__article_id ? 'i18n-advanced-textarea' : 'advanced-textarea'}
                            value={
                                void 0 !== this.props.content.original || !this.props.article.translated_from__article_id
                                    ? this.props.content
                                    : {
                                          ...this.props.content,
                                          original: this.props.content.source,
                                          source: undefined,
                                      }
                            }
                            onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                            validityFn={this.validityFn}
                            cleanUp={this.state.cleanUp}
                            convertLinks={this.state.convertLinks}
                        />
                    </div>
                </div>
            )
            // return this.renderContent('blah')
        } else if (this.props.type === 'article') {
            // console.log({ site: this.props.site }, this.props.content)
            const { content, meta = {}, article } = this.props
            const target_permalink = this.props.site?.permalink_array?.find((p) => p.id == meta.article_id)
            // console.log({ target_permalink })
            const description_selected = typeof meta?.type === 'undefined' || meta?.type === 'description'
            const onChangeType = (e) => {
                console.log(e.target.value)
                this.updateMeta({
                    ...meta,
                    type: e.target.value,
                })
            }
            return this.renderContent(
                <div className="article-link">
                    <Input
                        type="select"
                        value={meta?.article_id}
                        options={this.props.site?.permalink_array || []}
                        onChange={(e) => this.updateMeta({ article_id: e.id }, true)}
                    />
                    <strong className="d-inline-block my-2">Text</strong>
                    <div className="form-check">
                        <input
                            type="radio"
                            id={'article-text-description-' + this.props.id}
                            name={'article-text-' + this.props.id}
                            checked={description_selected}
                            onChange={onChangeType}
                            className="form-check-input"
                            value="description"
                        />
                        <label className="form-check-label" htmlFor={'article-text-description-' + this.props.id}>
                            Description
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            type="radio"
                            id={'article-text-manual-' + this.props.id}
                            name={'article-text-' + this.props.id}
                            checked={!description_selected}
                            onChange={onChangeType}
                            className="form-check-input"
                            value="manual"
                        />
                        <label className="form-check-label" htmlFor={'article-text-manual-' + this.props.id}>
                            Manual
                        </label>
                    </div>
                    {(target_permalink &&
                        ((description_selected && (
                            <div key="description" className="textarea" style={{ opacity: 0.5 }}>
                                {target_permalink.description}
                            </div>
                        )) || (
                            <div>
                                {(article.translated_from__article_id && (
                                    <Input
                                        type={'i18n-advanced-textarea'}
                                        value={
                                            void 0 !== content.original
                                                ? content
                                                : {
                                                      ...content,
                                                      original: content.source,
                                                      source: undefined,
                                                  }
                                        }
                                        onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                                        validityFn={this.validityFn}
                                        cleanUp={this.state.cleanUp}
                                        convertLinks={this.state.convertLinks}
                                    />
                                )) || (
                                    <div className="textarea">
                                        <Input
                                            type={'advanced-textarea'}
                                            value={content?.source ? content : undefined}
                                            onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                                            validityFn={this.validityFn}
                                            cleanUp={this.state.cleanUp}
                                            convertLinks={this.state.convertLinks}
                                        />
                                    </div>
                                )}
                            </div>
                        ))) ||
                        null}
                </div>
            )
            // return this.renderContent('blah')
        } else if (this.props.type === 'text') {
            return this.renderContent(
                <Input
                    type="advanced-textarea"
                    value={this.props.content}
                    onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                    validityFn={this.validityFn}
                    cleanUp={this.state.cleanUp}
                    convertLinks={this.state.convertLinks}
                />
            )
            // return this.renderContent('blah')
        } else if (this.props.type === 'i18n-text') {
            const content =
                void 0 !== this.props.content.original
                    ? this.props.content
                    : {
                          ...this.props.content,
                          original: this.props.content.source,
                          source: undefined,
                      }
            return this.renderContent(
                <Input
                    type="i18n-advanced-textarea"
                    value={content}
                    onChange={debounce(this.updateContent, INPUT_DEBOUNCE_TIME)}
                    validityFn={this.validityFn}
                    cleanUp={this.state.cleanUp}
                    convertLinks={this.state.convertLinks}
                />
            )
            // return this.renderContent('blah')
        } else if (typeof this.props.content !== 'undefined') {
            return this.renderContent(this.props.id + '-' + this.props.content)
        } else if (this.props.block_id_array) {
            const { block_id_array, content, ...props } = this.props
            switch (true) {
                case this.props.type === '3cols' || this.props.type === '2cols':
                    return (
                        <div className="row align-items-end page-editor-block" id={`block-${this.props.id}`}>
                            <BlockIcons
                                id={this.props.id}
                                onDragStart={this.onDragStart}
                                askToDeleteBlock={this.props.askToDeleteBlock}
                                visible={typeof this.props.visible === 'undefined' ? true : this.props.visible}
                                setVisible={this.setVisible}
                            />
                            {/* {this.props.block_id_array.map(block_id => { const block = this.props.body.find(block=>block.id===block_id); return <div className="col" key={`block-${block.id}`}>{this.renderDroppable(<Block key={`block-${block.id}`} {...props} {...block} />, block.id)}</div> })} */}
                            {this.props.block_id_array.map((block_id) => {
                                const block = this.props.body.find((block) => block.id === block_id)
                                return (
                                    <div className="col-lg" key={`block-${block.id}`}>
                                        {<Block key={`block-${block.id}`} {...props} {...block} />}
                                    </div>
                                )
                            })}
                        </div>
                    )
                default:
                    return this.renderDroppable(
                        this.props.block_id_array.map((block_id) => {
                            // console.log('trying to locate', block_id, 'in', this.props.body)

                            const block = this.props.body.find((block) => block.id === block_id)
                            return <Block key={`block-${block.id}`} {...props} {...block} />
                        })
                    )
            }
        } else {
            console.log('here', this.props)
            return null
        }
    }
}

const BlockIcons = (props) => {
    const type = new_block_array.find((i) => i.type === props.type)
    return (
        <div className="page-editor-block-icons-container">
            <div className="page-editor-block-type">
                <span className="d-inline-block mr-2">{type?.icon}</span>
                {type?.label}
            </div>
            <div className="page-editor-block-icons">
                <div className="page-editor-icon-btn" draggable={true} onDragStart={(e) => props.onDragStart(e, props.id)}>
                    <i className="fal fa-grip-horizontal" />
                </div>
                <div className="page-editor-icon-btn" draggable={true} onClick={(e) => props.setVisible(!props.visible)}>
                    {(props.visible && (
                        <span key="visible">
                            <i className="fal fa-eye" />
                        </span>
                    )) || (
                        <span key="not-visible">
                            <i className="fal fa-eye-slash" />
                        </span>
                    )}
                </div>
                {props.addon}
                <div className="page-editor-icon-btn trash" onClick={() => props.askToDeleteBlock(props.id)}>
                    <i className="fal fa-trash-alt" />
                </div>
            </div>
        </div>
    )
}

class AmazonBlock extends React.PureComponent {
    initialized = false
    state = { status: 'ready' }
    onImageChange = (e) =>
        this.props.onChange({
            target: {
                value: {
                    ...this.props.content,
                    image: e.target.value,
                    href: e.target.value.href || this.props.content.href,
                    href: e.target.value.href,
                },
            },
        })
    onLinkChange = (link) =>
        this.props.onChange({
            target: {
                value: {
                    ...this.props.content,
                    ...link,
                    image: { ...this.props.content?.image, href: link.href },
                },
            },
        })

    componentDidMount() {
        if ((!this.props.content || this.props.content === amazon_default_content) && this.props.payload) {
            this.initializeFromPayload(this.props.payload)
        }
    }

    componentDidUpdate(prevProps) {
        // console.log('componentDidUpdate called')
        // console.log(this.props.payload, this.initialized)
        {
            /* console.log('UPDATED', prevProps, this.props) */
        }
        if (!prevProps.payload && this.props.payload && !this.initialized) {
            this.initializeFromPayload(this.props.payload)
        }
    }

    initializeFromPayload = (payload) => {
        this.setState({ status: 'loading' })
        // console.log('calling initializeFromPayload')
        this.setAmazonBlockContent(this.props.payload)
        this.initialized = true
    }

    setAmazonBlockContent = (param) => {
        const obj = { ...param, article_id: this.props.article_id }
        // console.log({ ...Object.keys(obj).reduce((acc, key) => { if(typeof obj[key] === 'object'){ acc[key] = JSON.stringify(obj[key]) } else { acc[key] = obj[key]; }; return acc }, {}), article_id: this.props.article_id, block_id: this.props.block_id })
        post('link', {
            ...Object.keys(obj).reduce((acc, key) => {
                if (typeof obj[key] === 'object') {
                    acc[key] = JSON.stringify(obj[key])
                } else {
                    acc[key] = obj[key]
                }
                return acc
            }, {}),
            article_id: this.props.article_id,
            block_id: this.props.block_id,
        }).then((r) => {
            this.setState({ status: 'ready' })
            this.props.onChange({ target: { value: r } })
        })
    }

    isUnavailable = () => this.props.unavailable_link_array && this.props.unavailable_link_array.find((i) => i.external_id === this.props.content.external_id)

    render() {
        return (
            <React.Fragment>
                {(this.state.status === 'loading' && <Loading />) || (
                    <div className={(this.isUnavailable() && false && 'unavailable-link') || ''}>
                        {(this.props.content.image && (
                            <>
                                {/* <ImageEdit
                                    content={{ ...this.props.content.image, href: this.props.content.href }}
                                    onChange={this.onImageChange}
                                    article={this.props.article}
                                /> */}
                                <ImageUpload
                                    image={{
                                        ...this.props.content.image,
                                        href: this.props.content.href,
                                    }}
                                    image_key={this.props.image_key || undefined}
                                    parent_model={'article'}
                                    parent_id={this.props.article_id}
                                    parent={this.props.article}
                                    article={this.props.article}
                                    site_id={this.props.site_id}
                                    content={this.props.content}
                                    link={this.props.content}
                                    onChange={this.onImageChange}
                                    onLinkChange={this.onLinkChange}
                                    display_target={true}
                                    display_external_id={true}
                                    block_id={this.props.block_id}
                                />
                            </>
                        )) ||
                            null}
                        {/* <div onClick={() => this.props.setAmazonSelectorVisible(true, this.setAmazonBlockContent)}>Amazon</div> */}
                    </div>
                )}
            </React.Fragment>
        )
    }
}

export default withRouter(PageEditor)
